import { ToastrService } from "ngx-toastr";
import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { map, tap } from "rxjs/operators";
import { AuthService } from "./auth-services.service";
import Swal from "sweetalert2";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  validationError: any;
  validationErrorMessage: any;
  sweetAlert: any = {};
  tokenExpired: any;
  hasError: boolean;
  constructor(
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentClient = JSON.parse(localStorage.getItem("currentClient"));
    if (currentClient) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentClient}`,
        },
      });
      // request = request.clone({
      //   url: request.url + '?access_token=' + currentClient,
      // });
    }
    return next.handle(request).pipe(
      tap(
        (success: any) => {
          this.successHandler(request, success);
        },
        (err: any) => {
          this.errorHandler(err);

          if (err.status === 401) {
            this.auth.logout();
          }
          if (err.status === 502) {
            this.auth.logout();
          }
          // this.toastr.info(err.error.errors, "Unauthorized", {
          //   timeOut: 8000,
          // });
          if (err.error.status === 402) {
            this.validationError = err.error.errors[0];
            this.validationErrorMessage = err.error.message;
            // this.toastr.info(
            //   this.validationError,
            //   this.validationErrorMessage,
            //   {
            //     timeOut: 8000,
            //   }
            // );
          }
          this.tokenExpired = err.error.error;
          if (this.tokenExpired === "token_expired") {
            this.router.navigateByUrl("/");
            this.toastr.info(
              "Session Expired Please Login to Continue",
              "Session Expired",
              {
                timeOut: 8000,
              }
            );
            this.router.navigateByUrl("/");
          }
          if (err instanceof HttpErrorResponse) {
            if (err.error.status !== 401) {
              return;
            }
            // this.toastr.info(err.error.errors, "Error", {
            //   timeOut: 8000,
            // });
            // this.router.navigate(['login']);
          }
        }
      )
    );
  }

  getSweetAlert(data) {
    Swal.fire({
      ...data,
      showConfirmButton: this.hasError ? true : false,
      timer: this.hasError ? null : 1500,
      timerProgressBar: true,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
    //reset sweet alert data after showing
    this.sweetAlert = {};
  }

  errorHandler(response) {
    if ([400, 403, 404, 405, 409, 500].includes(parseInt(response.status))) {
      this.hasError = true;
      //this.sweetAlert.icon = "error";
      // this.sweetAlert.title = "Failed...";
      // this.sweetAlert.html = `<h3 style="color:red">${response.status}:${response.statusText ? response.statusText : response.message} .</h3>`;
      //this.sweetAlert.html = `<h3 style="color:red">${"There is a problem ,please contact system admininstrator"} .</h3>`;
      this.toastr.error(
        "Error",
        "There is a problem ,please contact system administrator "
      );
      return;
    } else if (parseInt(response.status) === 401) {
      // this.hasError = true;
      // this.sweetAlert.icon = "info";
      // this.sweetAlert.title = "Unauthorized";
      // this.sweetAlert.html = `<h3 style="color:red">${response.status}:${response.statusText ? response.statusText : response.message
      //   } .</h3>`;
      //this.sweetAlert.html = `<h3 style="color:red">${'There is a problem ,please contact system admininstrator'} .</h3>`;

      this.auth.clearSession();
      return;
    } else if (response.code === 422) {
      this.hasError = true;
      //this.sweetAlert.icon = "error";
      // this.sweetAlert.title = " Failed...";
      //this.sweetAlert.html = `<h3 style="color:red">422:${JSON.stringify(response.errors)} .</h3>`;
      // this.sweetAlert.html = `<h3 style="color:red">422:${"There is a problem,please contact system admininstrator"} .</h3>`;
      this.toastr.error(
        "Error",
        "There is a problem ,please contact system administrator "
      );
      return;
    } else {
      this.hasError = true;
      // this.sweetAlert.icon = "error";
      // this.sweetAlert.title = "Failed...";
      //this.sweetAlert.html = `<h3 style="color:red">${response.errors} .</h3>`;
      // this.sweetAlert.html = `<h3 style="color:red">${"There is a problem,contact system admininstrator"} .</h3>`;
      this.toastr.error(
        "Error",
        "There is a problem ,please contact system admininstrator "
      );
    }

    //this.getSweetAlert(this.sweetAlert);
    //return Promise.reject({ ...error });
  }

  successHandler(response, status) {
    /**
     * Add your url white lists in this array  that should not be intercepted by this interceptor
     */

    const urlBlackList = [
      "/api/quiz/integration/nida",
      "/api/fundSource/approveFundReallocation",
      "/api/cashbook",
    ];

    if (
      ["post", "put", "delete"].includes(response.method.toLowerCase()) &&
      !urlBlackList.includes(response.url)
    ) {
      if (status && status.body && status.body.code === 200) {
        this.hasError = false;
        this.sweetAlert.icon = "success";
        this.sweetAlert.title = `${
          status.body.description !== null
            ? status.body.description
            : response.method.toLowerCase() === "post"
            ? "Saved Successfully"
            : response.method.toLowerCase() === "put"
            ? "Updated Successfully"
            : "Deleted Successfully"
        } .`;
        //
        //console.log('response', response)
        //console.log('status', status)
        //

        if (
          response.method === "POST" &&
          status.body.access_token !== (null || undefined)
        ) {
          //on login hide sweet alert popup
          return;
        }

        this.getSweetAlert(this.sweetAlert);
      } else if (status && status.body && status.body.code !== 200) {
        //
        this.hasError = true;
        this.sweetAlert.icon = "error";
        this.sweetAlert.title =
          status.body.description !== null
            ? status.body.description
            : "Something went Wrong";
        if (
          response.method === "POST" &&
          status.body.access_token !== (null || undefined)
        ) {
          //on login hide sweet alert popup
          return;
        }
        this.getSweetAlert(this.sweetAlert);
      }
    } else if (
      /***
       * 8002 data not found, this error should not be shown

      */
      status &&
      status.body &&
      status.body.code !== undefined &&
      ![200, 8002].includes(status.body.code)
    ) {
      this.hasError = true;

      this.sweetAlert.icon = "error";
      this.sweetAlert.title =
        status.body.description !== null
          ? status.body.description
          : "Something went Wrong !";
      this.getSweetAlert(this.sweetAlert);
    }
  }
}
